/**
 * Dashboard API Hooks
 * TanStack Query v5使用
 */

import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from './index';
import type {
  KpiData,
  CheckinCheckoutData,
  WeeklyComparisonDataType,
  TodayScheduleData,
  AttendanceTrendDataType,
} from '../types/enhanced';
import type { KpiDetailData, KpiType } from '../types/kpiDetail';

/**
 * 個別セクションフック（並列フェッチ用）
 */

/**
 * KPI統計データフック
 */
export const useKpiData = () => {
  return useQuery<KpiData>({
    queryKey: ['dashboard', 'kpi'],
    queryFn: dashboardApi.getKpi,
    refetchInterval: 60000,
    staleTime: 30000,
  });
};

/**
 * 入退室データフック
 */
export const useCheckinCheckoutData = () => {
  return useQuery<CheckinCheckoutData>({
    queryKey: ['dashboard', 'checkin-checkout'],
    queryFn: dashboardApi.getCheckinCheckout,
    refetchInterval: 60000,
    staleTime: 30000,
  });
};

/**
 * 週比較データフック
 */
export const useWeeklyComparisonData = () => {
  return useQuery<WeeklyComparisonDataType>({
    queryKey: ['dashboard', 'weekly-comparison'],
    queryFn: dashboardApi.getWeeklyComparison,
    refetchInterval: 60000,
    staleTime: 30000,
  });
};

/**
 * 本日のスケジュールデータフック
 */
export const useTodayScheduleData = () => {
  return useQuery<TodayScheduleData>({
    queryKey: ['dashboard', 'today-schedule'],
    queryFn: dashboardApi.getTodaySchedule,
    refetchInterval: 60000,
    staleTime: 30000,
  });
};

/**
 * 出席率トレンドデータフック
 */
export const useAttendanceTrendData = () => {
  return useQuery<AttendanceTrendDataType>({
    queryKey: ['dashboard', 'attendance-trend'],
    queryFn: dashboardApi.getAttendanceTrend,
    refetchInterval: 60000,
    staleTime: 30000,
  });
};

/**
 * KPI詳細データフック
 * モーダル表示用の詳細データを取得
 */
export const useKpiDetailData = (kpiType: KpiType | null) => {
  return useQuery<KpiDetailData>({
    queryKey: ['dashboard', 'kpi-detail', kpiType],
    queryFn: () => dashboardApi.getKpiDetail(kpiType!),
    enabled: !!kpiType,
    staleTime: 30000,
  });
};
